import OverlayTips from "../OverlayTips";

function NotificationsPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

NotificationsPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle"), {
            messageKey: "tips.notifications.title",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: 10,
            offsetY: 15,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetY: 0
            }
        });

        this.add(function() { return $(".add-rule").not(".disabled-link").eqOrLast(0).find("td").eq(1) }, {
            messageKey: "tips.notifications.create_rule",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 5,
            offsetY: -20,
            outside: {
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -120,
                offsetY: 0
            }
        });

        this.add(function()
                 {
                     var $rule = $("#rulesTable .rule").eqOrLast(1);
                     if ($rule.length == 0)
                     {
                         return $rule;
                     }
                     else
                     {
                         // finds notification header for the rule
                         var $elem = $rule.prev();
                         while (!$elem.hasClass("notification-header"))
                         {
                             $elem = $elem.prev();
                         }
                         return $elem.find(".notification-title");
                     }
                 },
                 {
                     messageKey: "tips.notifications.edit_rule",
                     direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                     offsetX: -15,
                     offsetY: 45,
                     outside: {
                         direction: OverlayTips.DIRECTION_TOP_RIGHT,
                         offsetY: -20
                     }
                 });

        if (mailSettingsSpecified)
        {
            this.add($("#sendNotificationsNowDiv"), {
                messageKey: "tips.notifications.send",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -120,
                offsetY: 10
            });
        }

        this.add($(".scheduleButton").eqOrLast(0), {
            messageKey: "tips.notifications.schedule",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -40,
            offsetY: 5
        });

        this.add(function() { return $(".rule.stopped").eqOrLast(0).find(".remove-button img") }, {
            messageKey: "tips.notifications.resume_rule",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: 15,
            offsetY: 5
        });

        this.add(function() { return $("#rulesTable .rule.active").not(".edited").first().find(".remove-button img") }, {
            messageKey: "tips.notifications.pause_rule",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: 15,
            offsetY: 5
        });
    }
});

export default NotificationsPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/NotificationsPageOverlayTipsManager.js